import { render, staticRenderFns } from "./CInquirySignUpFloatingButtonGroup.vue?vue&type=template&id=5472e37c&"
import script from "./CInquirySignUpFloatingButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./CInquirySignUpFloatingButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports